import _ from 'lodash-es';

/**
 * @param address address as returned by the API
 * @param translate optional t() captured in setup(). Passed when formatting is called
 *   from an event handler, where useI18n() is no longer available.
 */
export default function (address, translate = null) {
  if (!address) return [];

  const t = translate ?? useI18n().t;
  const fullStreet = ((address?.street ? address?.street : '') + ' ' + (address?.streetNo ? address?.streetNo : '') + (address?.houseNo ? `/${address?.houseNo}` : '')).trim();
  const fullName = _.join(_.filter([ 
    address.namePrefix,
    address.firstName,
    address.lastName,
    address.nameSuffix
  ]), ' ').trim();

  // Carrier pickup point: the point name is shown instead of a recipient name.
  if (address?.carrier) {
    return _.filter([
      address?.pickupName,
      fullStreet,
      _.join(_.filter([address?.zip, address?.city]), ' '),
      address?.country?.name,
    ]);
  }

  return _.filter([
    address?.company !== fullName ? address?.company : null,
    address?.companyPerson ? address?.companyPerson : fullName,
    fullStreet,
    _.join(_.filter([address?.zip, address?.city]), ' '),
    address?.country?.name,
    address?.companyNo ? `${t('text-companyNo')}: ${address?.companyNo}` : null,
    address?.companyVatNo ? `${t('text-companyVatNo')}: ${address?.companyVatNo}` : null,
  ]);
}
